import { guardPasswordLinkToken } from "./password_link_token";

// Imported first by index.tsx, so this runs before any other module of the app
// is evaluated: nothing that could read the address — Sentry, a tracker, the
// router — exists yet.
guardPasswordLinkToken();
